import slugify from './slugify'

export default ({attributes = {}, e_attribute = {}}) => {
    if(typeof attributes !== 'object') {
        return null
    }
    const keys = Object.keys(attributes)
    let uid = []
    for(let i = 0; i < keys.length; i++) {
        if(attributes[keys[i]]) {
            uid.push(`${keys[i]}=${attributes[keys[i]]}`)
        }
    }

    const e_keys = Object.keys((e_attribute.options || {}))
    for(let i = 0; i < e_keys.length; i++) {
        if(e_attribute.options[e_keys[i]]) {
            uid.push(`${e_keys[i]}=${e_attribute.options[e_keys[i]].slug}`)
        }
    }

    return slugify(uid.sort().join('_'))
}
